module.exports = __webpack_public_path__ + "static/media/icon-report-sidebar-progress.4d65bd8d.svg";